import { createSlice } from "@reduxjs/toolkit";

export const FilterValueNavigation = createSlice({
  name: "filterValueNavigation",
  initialState: {
    entity: null,
    variable: null,
  },
  reducers: {
    setFilterValueNavigationState: (state, { payload }) => {        
      state.entity = payload.entity || null;
      state.variable = payload.variable || null;
    },
    resetFilterValueNavigationState: (state) => {
      state.entity = null;
      state.variable = null;
    },
  },
});

export const { setFilterValueNavigationState, resetFilterValueNavigationState } = FilterValueNavigation.actions;
export default FilterValueNavigation.reducer;